import { useQuery } from '@tanstack/react-query';
import { tenantsApi, type TenantListResponse } from '../api/services/tenants';

export function useTenants(params?: {
  search?: string;
  status?: string;
  type?: string;
}) {
  return useQuery<TenantListResponse>({
    queryKey: ['admin', 'tenants', params],
    queryFn: () => tenantsApi.list(params),
  });
}

/**
 * RBAC-aware "tenants this user can enter" hook. Drives the OrgSwitcher
 * contents and visibility (the dropdown self-hides when len <= 1). Replaces
 * the prior pattern of hard-gating on isPlatformAdmin and reusing useTenants.
 *
 * Platform admins receive apex + all active FI tenants; single-tenant FI
 * users receive just their tenant; multi-tenant FI users (C12FR->C13-6
 * follow-on) currently fall back to the JWT's single tenantId.
 */
export function useAccessibleTenants(options?: { enabled?: boolean }) {
  return useQuery<TenantListResponse>({
    queryKey: ['admin', 'tenants', 'accessible'],
    queryFn: () => tenantsApi.accessible(),
    enabled: options?.enabled ?? true,
  });
}
